module.exports = require("./gu-IN.js");